export const SIDEBAR_WIDTH = 250;
export const MIN_SIDEBAR_WIDTH = 70;
